/**
 * Drawer toggle script.
 * Uses event delegation — no per-element listeners needed.
 * GSAP stagger animation on open.
 */
(function () {
  var html = document.documentElement;

  function animateIn(drawer) {
    var panel = drawer.querySelector('.header__drawer-panel, .header__left-panel');
    if (!panel || typeof gsap === 'undefined') return;

    var children = panel.querySelectorAll('.header__drawer-group, .header__left-group');
    if (!children.length) return;

    gsap.fromTo(children,
      { opacity: 0, y: 11 },
      { opacity: 1, y: 0, duration: 0.32, stagger: 0.05, ease: 'power2.out', delay: 0.12 }
    );
  }

  function resetAnim(drawer) {
    var panel = drawer.querySelector('.header__drawer-panel, .header__left-panel');
    if (!panel || typeof gsap === 'undefined') return;

    var children = panel.querySelectorAll('.header__drawer-group, .header__left-group');
    if (!children.length) return;

    gsap.set(children, { clearProps: 'all' });
  }

  function open(drawer, trigger) {
    drawer.classList.add('is-open');
    if (trigger) {
      drawer.__opener = trigger;
      trigger.setAttribute('aria-expanded', 'true');
    }
    html.classList.add('scroll-lock');
    animateIn(drawer);

    // Move focus into the drawer synchronously, within the user gesture, so the
    // mobile soft keyboard opens (deferred focus does not raise it on iOS).
    var focusEl = drawer.querySelector('[data-drawer-autofocus]');
    if (focusEl) focusEl.focus();

    if (drawer.hasAttribute('data-cart-drawer') && window.renderCartDrawer) {
      window.renderCartDrawer();
    }
  }

  function close(drawer) {
    drawer.classList.remove('is-open');
    // Reset aria-expanded on whatever actually opened this drawer (the trigger
    // may live outside the drawer — e.g. the header Search / cart buttons) and
    // return focus to it.
    var trigger = drawer.__opener || drawer.querySelector('[data-drawer-toggle]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (typeof trigger.focus === 'function') trigger.focus();
    }
    // Release the shared scroll lock only when no other drawer remains open.
    if (!document.querySelector('[data-drawer].is-open')) {
      html.classList.remove('scroll-lock');
    }
    resetAnim(drawer);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      var target = toggle.getAttribute('data-drawer-toggle');

      // Cart / search toggles target their own global drawer
      var drawer;
      if (target === 'cart') {
        drawer = document.querySelector('[data-cart-drawer]');
      } else if (target === 'search') {
        drawer = document.querySelector('[data-search-drawer]');
      } else {
        drawer = toggle.closest('[data-drawer]');
      }

      if (!drawer) return;

      if (drawer.classList.contains('is-open')) {
        close(drawer);
      } else {
        open(drawer, toggle);
      }
      return;
    }

    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      var drawer = closer.closest('[data-drawer]');
      if (drawer) close(drawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openDrawer = document.querySelector('[data-drawer].is-open');
      if (openDrawer) close(openDrawer);
    }
  });

  /* ── Cart drawer rendering ── */

  function formatMoney(cents) {
    var dollars = cents / 100;
    if (cents % 100 === 0) {
      return '$' + Math.round(dollars).toLocaleString('en-US');
    }
    return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  window.renderCartDrawer = function () {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var body = document.querySelector('[data-cart-drawer-body]');
        var footer = document.querySelector('[data-cart-drawer-footer]');
        if (!body || !footer) return;

        if (cart.items.length === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
          footer.style.display = 'none';
          return;
        }

        footer.style.display = '';
        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-drawer__item" data-line-key="' + item.key + '">';
          html += '<img class="cart-drawer__item-image" src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '">';
          html += '<div class="cart-drawer__item-details">';
          html += '<span class="cart-drawer__item-title">' + item.product_title + '</span>';
          if (item.variant_title) html += '<span>' + item.variant_title + '</span>';
          html += '<span>' + formatMoney(item.final_line_price) + '</span>';
          html += '<span>Qty: ' + item.quantity + '</span>';
          html += '<button class="cart-drawer__item-remove" data-remove-key="' + item.key + '">Remove</button>';
          html += '</div></div>';
        });
        body.innerHTML = html;

        // Subtotal
        var subtotalEl = footer.querySelector('.cart-drawer__subtotal');
        if (!subtotalEl) {
          subtotalEl = document.createElement('div');
          subtotalEl.className = 'cart-drawer__subtotal';
          footer.insertBefore(subtotalEl, footer.firstChild);
        }
        subtotalEl.innerHTML = '<span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span>';
      });
  };

  /* ── Remove item from cart ── */

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-key]');
    if (!removeBtn) return;

    var key = removeBtn.dataset.removeKey;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function () {
      window.renderCartDrawer();
      if (window.updateCartCount) window.updateCartCount();
      document.dispatchEvent(new CustomEvent('cart:changed'));
    });
  });
})();
